import { NgModule } from '@angular/core';
import { authenticationGuardInjectionToken } from "./session/authentication-guard-injection-token";
import { AuthenticationGuard } from "./session/authentication-guard.service";
import { CanDeactivateGuard } from "./page/can-deactivate.guard";

@NgModule( {
  providers: [
    {
      provide: authenticationGuardInjectionToken,
      useClass: AuthenticationGuard
    }, CanDeactivateGuard
  ]
} )
export class GuardsModule {
}
